<template>
    <div>
        <button @click="showSingle">Show single picture.</button>
        <button @click="showMultiple">Show a group of pictures.</button>
        <VueEasyLightbox :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></VueEasyLightbox>

        <!-- Component name: 'vue-easy-lightbox' -->

        <!-- <vue-easy-lightbox :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></vue-easy-lightbox> -->
    </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
export default {
    data() {
        return {
            imgs: [
                "https://dummyimage.com/800/ffffff/000000",
                "https://dummyimage.com/1600/ffffff/000000",
                "https://dummyimage.com/1280/000000/ffffff",
                "https://dummyimage.com/400/000000/ffffff"
            ], // Img Url , string or Array
            visible: false,
            index: 0 // default
        };
    },
    methods: {
        showSingle() {
            this.show();
        },
        showMultiple() {
            this.index = 1; // index of imgList
            this.show();
        },
        show() {
            this.visible = true;
        },
        handleHide() {
            this.visible = false;
        }
    },
    components: {
        VueEasyLightbox
    }
};
</script>


// WEBPACK FOOTER //
// src/test/gallery2.vue